import React, { FunctionComponent } from 'react';
import { Input, ErrorMessage } from 'react-design-components';
import FormComponentProps from '../FormComponentProps';

interface FormData {
  email?: string;
}

const EmailInput: FunctionComponent<FormComponentProps<FormData>> = ({ t, register, errors, defaultValue }) => {
  return (
    <>
      <Input
        inputProps={register('email', {
          required: t('validation.email.required'),
          pattern: {
            value:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
            message: t('validation.email.format'),
          },
        })}
        id="email"
        type="email"
        label={t('email')}
        error={!!errors.email}
        InputLabelProps={{
          htmlFor: 'email',
        }}
        defaultValue={defaultValue}
      />
      {!!errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
    </>
  );
};

export default EmailInput;
